module.exports = __webpack_public_path__ + "img/Group_11889-1.a7fe6b25.svg";